export const ID_PREFIX = {
  BALANCE: "bil_balance_",
  RESERVATION: "bil_reservation_",
} as const;
